import { Component, Input, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { listArticle } from 'src/interface/article';

@Component({
  selector: 'app-article-search-list',
  templateUrl: './article-search-list.component.html',
  styleUrls: ['./article-search-list.component.scss']
})
export class ArticleSearchListComponent implements OnInit {
  @Input() searchedArticles: listArticle[] = [];
  @Input() journalid: string;
  @Input() valueForSearch: string;
  @Input() tempSearchArticles: listArticle[] = [];
  @Input() color;
  @Input() show_search_list: boolean;
  @Input() loading: boolean;
  @Input()searchListLoaderContent:boolean;
  search_list_loader = new Array(2).fill(0);
  constructor(
    @Inject(PLATFORM_ID) private platformId: any
  ) { }
  ngOnInit(): void {
    
    if (this.searchedArticles.length != 0) {
      setTimeout(() => {
        this.loading = false;
      }, 500);

    }
   
    if (isPlatformBrowser(this.platformId) && this.color) {
      Object.entries(this.color).map(([key, value]) => {
        const element = "--" + key;
        const val = value;
        document.documentElement.style.setProperty(element, String(val));
      });

    }
  }

  changeIssue(issue: any) {
    // Regular expression pattern to match 'and'
    const pattern = /and/;
    let outputString: string = 'Issue ' + issue;
    if (issue.match(pattern)) {
        // Replace 'and' with '/'
        outputString = 'Issue ' + issue.replace(pattern, ' & ');
    }

    // Regular expression pattern to match 's' followed by a number
    const nextpattern = /s(\d+)/;

    if (issue.match(nextpattern)) {
        const issue_num =issue.match(nextpattern)[1];
        // Replace 's' followed by a number with 'supplementary issue' followed by that number
        outputString = issue.replace(nextpattern, 'Supplementary issue ' + issue_num);
    }

    if(issue == 'non-issue'){
        outputString = 'Regular articles';
    }

    return outputString;
}

returnAuthor(author){
  let name = '';
  if(author?.specific_use){
      name += 'in conversation with ';
  }
  name += author.first_name+' '+author.last_name;
  return name;
}

}
